const ADJECTIVES = [
    "Fruity",       // Fruity Frog
    "Citrus",       // Citrus Cobra
    "Tropical",     // Tropical Tiger
    "Wildberry",    // Wildberry Wolf
    "Watermelon",   // Watermelon Whale
    "Blueberry",    // Blueberry Bear
    "Raspberry",    // Raspberry Raptor
    "Strawberry",   // Strawberry Shark
    "Peach",        // Peach Panther
    "Cherry",       // Cherry Cheetah
    "Pomegranate",  // Pomegranate Piranha
    "Dragonfruit",  // Dragon Fruit Dragon
    "Grapefruit",   // Grapefruit Giraffe
    "Bubblegum",    // Bubblegum Butterfly
    "Lollipop",     // Lollipop Lovebird
    "BloodOrange",  // Blood Orange Bat
    "Acai",         // Acai Anaconda
    "Cactus",       // Cactus Camel
    "Holy",         // Marque
    "Giga"          // Giga Gallon
];

// Mix: Les mascottes officielles HOLY + Objets/Foot
const NOUNS = [
    "Raptor",     // Raspberry Raptor
    "Cobra",      // Citrus Cobra
    "Tiger",      // Tropical Tiger
    "Shark",      // Strawberry Shark
    "Wolf",       // Woodruff / Wildberry Wolf
    "Panther",    // Peach Panther
    "Whale",      // Watermelon Whale
    "Bear",       // Blueberry Bear
    "Gorilla",    // Gorilla's Grape
    "Dragon",     // Dragon Fruit Dragon
    "Bat",        // Blood Orange Bat
    "Cheetah",    // Cherry Cheetah
    "Kiwi",     // Kiwi Komodo
    "Piranha",    // Pomegranate Piranha
    "Frog",       // Fruity Frog
    "Alligator",  // Apple Alligator
    "Lion",       // Lion's Lemonade
    "Toucan",     // Thai Lime Toucan
    "Camel",      // Cactus CamelgenerateHolyPseudo
    "Lizard",     // Lemon Lizard
    "Giraffe",    // Grapefruit Giraffe
    "Anaconda",   // Acai Anaconda
    "Shaker",     // Produit star
    "Gallon"      // Produit Giga Gallon
];


export const generateHolyPseudo = () => {
    const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
    const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];

    return `${adj}${noun}`;
};